import { defineMessages } from "react-intl"

export default defineMessages({
  pageTitle: {
    id: "app.pages.SessionConfirm.pageTitle",
  },
  oops: {
    id: "app.pages.SessionConfirm.oops",
  },
  invalidParticipation: {
    id: "app.pages.SessionConfirm.invalidParticipation",
  },
  contactUs: {
    id: "app.pages.SessionConfirm.contactUs",
  },
  confirmHeader: {
    id: "app.pages.SessionConfirm.confirmHeader",
  },
  confirmText: {
    id: "app.pages.SessionConfirm.confirmText",
  },
})
